import React from 'react';

const Notification = ({ message }) => {
  return (
    <div>
      <p>{message}</p>
    </div>
  );
};
export default Notification;
